<i18n>
{
    "ru": {
        "sample": "Есть пробник!",
        "more": "Подробнее"
    }
}
</i18n>

<template>
    <html-link :url="computedUrl"
        class="diagnostic-offer"
        @click.native="gaEventHandler('4_click', 'Клик по товару')"
        :target="isDeviceDesktop ? '_blank' : false">
        <div class="diagnostic-offer__content">
            <div class="diagnostic-offer__picture">
                <img
                    v-lazy-load :data-src="get(options, 'picture.url', getPerfumeNoImage)"
                    :alt="get(options, 'picture.alt', '')" />
                <div class="diagnostic-offer__sample" v-if="isSample">{{ $t('sample') }}</div>
            </div>
            <div class="diagnostic-offer__name">{{ options.name }}</div>
            <div class="diagnostic-offer__brand">{{ get(options, 'brand.name', '') }}</div>
            <div class="diagnostic-offer__type">{{ get(options, 'concentration.name', '') }}</div>
            <div class="diagnostic-offer__price" v-if="computedPrice">{{ computedPrice }}</div>
            <div v-if="computedRating"
                class="rating diagnostic-offer__rating"
                :data-value="computedRating">
            </div>
            <div class="diagnostic-offer__more">{{ $t('more') }}</div>
        </div>
    </html-link>
</template>

<script>
import get from 'lodash/get'

import { mapGetters } from 'vuex'

export default {
    name: 'BlockDiagnosticOffer',
    props: {
        options: {
            type: Object,
            default: () => {}
        }
    },
    data(){
        return{
            googleEvents: true
        }
    },
    computed: {
        ...mapGetters(['getPerfumeNoImage', 'isDeviceDesktop']),
        isSample(){
            return get(this.options, 'prices.samplesAvailable', false);
        },
        computedRating(){
            const rate = get(this.options, 'ratings.value', -1);
            return Math.round(rate / 0.5) * 0.5;
        },
        computedPrice(){
            const priceFrom = get(this.options, 'prices.priceFrom', 0);
            const priceTo = get(this.options, 'prices.priceTo', 0);
            const currency = get(this.options, 'prices.currency');

            if(priceFrom === 0 && priceTo === 0)
                return false

            if(priceFrom === priceTo)
                return this.$options.filters.numberFormat(priceFrom) + ` ${currency}`;

            return `${this.$options.filters.numberFormat(priceFrom)} - ${this.$options.filters.numberFormat(priceTo)} ${currency}`
        },
        computedUrl(){
            return this.options.htmlUrl + '?r1=recommendations&r2=user_personalized_set';
        }
    },
    methods: {
        get,
        gaEventHandler(action, label){
            if(this.googleEvents)
                this.$ga.event('diagnostics', action, label)
        }
    }
}
</script>

<style lang="less">
.diagnostic-offer{
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    font-size: rem(13);
    line-height: rem(20);
    color: @color-black;
    height: 100%;
    position: relative;

    @{mobile} & {
        padding-left: 0;
        padding-right: 0;
    }

    &__content{
        padding: rem(20);
        transition: box-shadow .2s ease;
    }

    &__picture{
        width: rem(158);
        height: rem(158);
        position: relative;
        margin: 0 auto rem(20);
        display: block;

        img{
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    &__sample{
        position: absolute;
        bottom: rem(-10);
        left: 0;
        right: 0;
        margin: 0 auto;
        background-color: @color-white-pink;
        font-size: rem(11);
        line-height: rem(17);
        padding: rem(3) rem(4) rem(1);
        border-radius: rem(3);
        font-weight: 500;
        color: @color-black;
        width: rem(86);
    }

    &__name{
        max-width: 100%;
        margin-bottom: rem(2);
        font-weight: 500;
        font-size: rem(15);
        line-height: rem(23);
        .text-ellipsis(1);
    }

    &__brand{
        max-width: 100%;
        margin-bottom: rem(2);
        text-transform: uppercase;
        color: @color-gray-light;
        letter-spacing: 0.04em;
        font-size: rem(12);
        line-height: rem(15);
        font-weight: 500;
        .text-ellipsis(1);
    }

    &__type{
        color: @color-gray;
        margin-bottom: rem(8);
    }

    &__price{
        font-weight: 500;
        font-size: rem(14);
        line-height: rem(21);
        margin-bottom: rem(8);
    }

    &__rating{
        --star-width: rem(11);
        --star-height: rem(11);
        margin-bottom: rem(8);
    }

    &__more{
        color: @color-gray;
        text-decoration: underline;

        .hover({
            text-decoration: none;
        });
    }

    .hover({
        .diagnostic-offer{
            &__name{
                .text-ellipsis(2);
            }

            &__content{
                background-color: @color-white;
                box-shadow: 0 rem(1) rem(8) rgba(0, 0, 0, 0.1);
                position: absolute;
                width: 100%;
                top: 0;
                left: 0;
            }
        }
    });
}
</style>